"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = require("react-dom/client");
// https://react.i18next.com/
const react_i18next_1 = require("react-i18next");
const App_1 = __importDefault(require("./components/App"));
const i18n_1 = __importDefault(require("./i18n"));
require("./printBuildInfo");
const styles_1 = require("./styles");
const container = document.querySelector('#root');
if (!container) {
    throw new Error('Root element not found');
}
const root = (0, client_1.createRoot)(container);
root.render((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(styles_1.GlobalStyle, {}), (0, jsx_runtime_1.jsx)(react_i18next_1.I18nextProvider, { i18n: i18n_1.default, children: (0, jsx_runtime_1.jsx)(App_1.default, {}) })] }));
